import { render, staticRenderFns } from "./searchpage.vue?vue&type=template&id=5c200aa4&scoped=true"
import script from "./searchpage.vue?vue&type=script&lang=js"
export * from "./searchpage.vue?vue&type=script&lang=js"
import style0 from "./searchpage.vue?vue&type=style&index=0&id=5c200aa4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c200aa4",
  null
  
)

export default component.exports